export const FORGE_APP_ID = process.env.VUE_APP_FORGE_APP_ID

export const FORGE_ENVIRONMENT_ID = process.env.VUE_APP_FORGE_ENVIRONMENT_ID

export const FORGE_CONFLUENCE_APP_ID = process.env.VUE_APP_FORGE_CONFLUENCE_APP_ID

export const FORGE_CONFLUENCE_ENVIRONMENT_ID = process.env.VUE_APP_FORGE_CONFLUENCE_ENVIRONMENT_ID

export { invoke as forgeInvoke, view as forgeView, router as forgeRouter } from '@forge/bridge'

export {
  CreateIssueModal as forgeCreateIssueModal,
  ViewIssueModal as forgeViewIssueModal
} from '@forge/jira-bridge'
